export const URL_SEARCH_PARAMS = {
  CONTRACTOR_ID: "contractorId",
  DATE: "date",
  FROM_DATE: "fromDate",
  TO_DATE: "toDate",
  INSTALLATION_REF: "installationRef",
  SENSORS_IDS: "sensorIds",
  PROPERTIES: "properties",
  DEVICE_ID: "deviceId",
  SAMPLING_RATE: "samplingRate",
  TOKEN: "token",
  TAB: "tab",
} as const;
